import _ from 'lodash';
import QuestionnaireVisitor from '../QuestionnaireVisitor';
import { isOptionField, } from '../structure';
class FilterNodesByUserTypesVisitor extends QuestionnaireVisitor {
    userTypes;
    constructor(userTypes) {
        super();
        this.userTypes = userTypes;
    }
    visitQuestionnaire(questionnaire) {
        const clonedQuestionnaire = _.cloneDeep(questionnaire);
        const filteredQuestionnaire = this.filterNodesByPlatformType(clonedQuestionnaire);
        super.visitQuestionnaire(filteredQuestionnaire);
        return { questionnaire: filteredQuestionnaire, output: undefined };
    }
    visitSectionGroup(sectionGroup) {
        sectionGroup.sections = this.filterNodesByPlatformType(sectionGroup.sections);
        super.visitSectionGroup(sectionGroup);
    }
    visitSection(section) {
        section.subsections = this.filterNodesByPlatformType(section.subsections);
        super.visitSection(section);
    }
    visitSubsection(subsection) {
        subsection.fieldGroups = this.filterNodesByPlatformType(subsection.fieldGroups);
        super.visitSubsection(subsection);
    }
    visitFieldGroup(fieldGroup) {
        fieldGroup.fields = this.filterNodesByPlatformType(fieldGroup.fields);
        super.visitFieldGroup(fieldGroup);
    }
    visitField(field) {
        if (isOptionField(field)) {
            if (field.options?.length > 0) {
                field.options = this.filterNodesByPlatformType(field.options);
            }
        }
    }
    filterNodesByPlatformType(nodes) {
        return nodes.filter((node) => this.nodeHasMatchingPlatformTypes(node));
    }
    nodeHasMatchingPlatformTypes(baseNode) {
        if (!baseNode.platformTypeFilter?.length) {
            // No platform type means this should always be included.
            return true;
        }
        const matches = _.intersection(baseNode.platformTypeFilter, this.userTypes);
        return !_.isEmpty(matches);
    }
}
export function filterNodesByPlatformType(questionnaire, userTypes) {
    if (!userTypes.length) {
        return questionnaire;
    }
    const visitor = new FilterNodesByUserTypesVisitor(userTypes);
    const { questionnaire: filteredQuestionnaire } = visitor.visitQuestionnaire(questionnaire);
    return filteredQuestionnaire;
}
